import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./NotFound404.css";

export default function NotFound404({
  // reason: "route" | "no-license"
  reason = "route",
  agentName,
  agentSlug,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const isNoLicense = reason === "no-license";

  const title = isNoLicense ? "License Not Found" : "Page Not Found";

  const subtitle = isNoLicense
    ? agentName
      ? `We couldn't find any active licenses on file for ${agentName}.`
      : "We couldn't find any active licenses on file for this agent."
    : "The page you’re looking for doesn’t exist or the link is broken.";

  const ctaPrimaryLabel = isNoLicense ? "View All Agents" : "Go Home";

  const actions = (
    <div className="nf-actions">
      {isNoLicense ? (
        <>
          <Link className="nf-btn" to="/agents">
            View All Agents
          </Link>
          <button
            className="nf-btn nf-outline"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            Go Back
          </button>
          <Link
            className="nf-link"
            to="/contact"
            state={{
              from: location.pathname,
              issue: "No license on file",
              agentSlug,
            }}
          >
            Report an issue
          </Link>
        </>
      ) : (
        <>
          <Link className="nf-btn" to="/">
            Go Home
          </Link>
        </>
      )}
    </div>
  );

  return (
    <main className="nf-wrap" role="main">
      <section className="nf-card" aria-labelledby="nf-title">
        <div className="nf-code" aria-hidden="true">
          404
        </div>
        <h1 id="nf-title" className="nf-title">
          {title}
        </h1>
        <p className="nf-subtitle">{subtitle}</p>

        {isNoLicense && (
          <p className="nf-note">
            If you’re this agent and believe this is an error, please{" "}
            <Link
              to="/contact"
              state={{
                from: location.pathname,
                issue: "License upload help",
                agentSlug,
              }}
            >
              contact support
            </Link>{" "}
            to upload your license documents.
          </p>
        )}

        {actions}
      </section>
    </main>
  );
}
